export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGIN_FAIL="LOGIN_FAIL";
export const LOGIN_REQUEST="LOGIN_REQUEST";
export const LOGOUT="LOG_OUT";
export const LOAD_PROFILE="LOAD_PROFILE";

export const HOME_VIDEOS_SUCCESS = "HOME_VIDEOS_SUCCESS";
export const HOME_VIDEOS_FAIL = "HOME_VIDEOS_FAIL";
export const HOME_VIDEOS_REQUEST = "HOME_VIDEOS_REQUEST";

export const SELECTED_VIDEO_REQUEST = "SELECTED_VIDEO_REQUEST";
export const SELECTED_VIDEO_SUCCESS = "SELECTED_VIDEO_SUCCESS";
export const SELECTED_VIDEO_FAIL = "SELECTED_VIDEO_FAIL";

export const CHANNEL_DETAILS_REQUEST = "CHANNEL_DETAILS_REQUEST";
export const CHANNEL_DETAILS_SUCCESS = "CHANNEL_DETAILS_SUCCESS";
export const CHANNEL_DETAILS_FAIL = "CHANNEL_DETAILS_FAIL";

export const SET_SUBSCRIPTION_STATUS = "SET_SUBSCRIPTION_STATUS";

export const COMMENT_LIST_REQUEST = "COMMENT_LIST_REQUEST";
export const COMMENT_LIST_SUCCESS = "COMMENT_LIST_SUCCESS";
export const COMMENT_LIST_FAIL = "COMMENT_LIST_FAIL";

export const CREATE_COMMENT_REQUEST = "CREATE_COMMENT_REQUEST";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAIL = "CREATE_COMMENT_FAIL";

export const RELATED_VIDEOS_REQUEST = "RELATED_VIDEOS_REQUEST";
export const RELATED_VIDEOS_SUCCESS = "RELATED_VIDEOS_SUCCESS";
export const RELATED_VIDEOS_FAIL = "RELATED_VIDEOS_FAIL";

export const SEARCH_VIDEO_REQUEST = "SEARCH_VIDEO_REQUEST";
export const SEARCH_VIDEO_SUCCESS = "SEARCH_VIDEO_SUCCESS";
export const SEARCH_VIDEO_FAIL = "SEARCH_VIDEO_FAIL";

export const SUBSCRIBED_CHANNELS_REQUEST = "SUBSCRIBED_CHANNELS_REQUEST";
export const SUBSCRIBED_CHANNELS_SUCCESS = "SUBSCRIBED_CHANNELS_SUCCESS";
export const SUBSCRIBED_CHANNELS_FAIL = "SUBSCRIBED_CHANNELS_FAIL";

export const CHANNEL_PLAYLIST_REQUEST = "CHANNEL_PLAYLIST_REQUEST";
export const CHANNEL_PLAYLIST_SUCCESS = "CHANNEL_PLAYLIST_SUCCESS";
export const CHANNEL_PLAYLIST_FAIL = "CHANNEL_PLAYLIST_FAIL";

export const MY_LIKED_VIDEOS_REQUEST = "MY_LIKED_VIDEOS_REQUEST";
export const MY_LIKED_VIDEOS_SUCCESS = "MY_LIKED_VIDEOS_SUCCESS";
export const MY_LIKED_VIDEOS_FAIL = "MY_LIKED_VIDEOS_FAIL";

export const GET_REGION_CODE_REQUEST = "GET_REGION_CODE_REQUEST";
export const GET_REGION_CODE_SUCCESS = "GET_REGION_CODE_SUCCESS";
export const GET_REGION_CODE_FAIL = "GET_REGION_CODE_FAIL";
